// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"305137c7","866":"81b07ff6","953":"863f9c70"}[chunkId] + ".chunk.js";
};